import { all, call, fork, put, takeEvery } from "bukku/shared/SagaService";
import actions from "./actions";
import { message } from "antd";
import AppActions from '../App/actions';
import {get, puto} from 'bukku/shared/ApiService';

export function* getPublicContactProfile() {
    yield takeEvery(actions.READ_PUBLIC_CONTACT_PROFILE_REQUEST, function* (action, context) {
        try{
            yield put({ type: AppActions.APP_START_PULLING });

            const {pathname} = window.location;
            const paths = pathname.substring(1).split('/');
            const hash = paths[1];

            const response = yield call(get, `/public/contacts/${hash}`, null, context);
            const data = yield response.data;
            
            yield put({
                type: actions.READ_PUBLIC_CONTACT_PROFILE_SUCCESS,
                contact: data.contact,
                company: data.company,
            })
        }
        catch (error) {
            yield put({
                type: actions.READ_PUBLIC_CONTACT_PROFILE_ERROR,
                error
            })
        }
        finally {
            yield put({ type: AppActions.APP_STOP_PULLING });
        }
    })
}

export function* updatePublicContactProfileRequest() {
    yield takeEvery(actions.UPDATE_PUBLIC_CONTACT_PROFILE_REQUEST, function* ({ request }, context) {
        try {
            yield put({ type: AppActions.APP_START_PUSHING });

            const {pathname} = window.location;
            const paths = pathname.substring(1).split('/');
            const hash = paths[1];

            const response = yield call(puto, `/public/contacts/${hash}`, request, context);
            const data = yield response.data;

            yield put({
                type: actions.UPDATE_PUBLIC_CONTACT_PROFILE_SUCCESS,
                contact: data.contact,
            });
        }
        catch (error) {
            yield put({
                type: actions.UPDATE_PUBLIC_CONTACT_PROFILE_ERROR,
                error,
            });
        }
        finally {
            yield put({ type: AppActions.APP_STOP_PUSHING });
        }
    });
}

export function* updatePublicContactProfileError() {
    yield takeEvery(actions.UPDATE_PUBLIC_CONTACT_PROFILE_ERROR, function* ({ error }) {
        yield message.error(error.message);
    });
}

export default function* rootSaga() {
    yield all([
        fork(getPublicContactProfile),
        fork(updatePublicContactProfileRequest),
        fork(updatePublicContactProfileError),
    ])
}